// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__eqhTQ","white_btn":"styles_white_btn__AC9RI"};